import { Link } from 'react-router-dom';
import BrandMark from '../components/BrandMark.jsx';

export default function QboDisconnected() {
  return (
    <div className="qbo-shell">
      <div className="qbo-card">
        <BrandMark size={48} />
        <h1>Disconnected from QuickBooks</h1>
        <p>
          DemandJet is no longer connected to this QuickBooks Online company. Open invoices will
          not sync and payments will not reconcile until you reconnect.
        </p>
        <a className="btn-primary" href="/server/quickbooks_api/launch">
          Reconnect with QuickBooks
        </a>
        <p className="qbo-footnote">
          Or return to the <Link to="/qbo">DemandJet for QuickBooks app</Link>.
        </p>
      </div>
    </div>
  );
}
